import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Loader2, Zap } from 'lucide-react'
import { useEffect, useState } from 'react'
import { supabase } from '@/integrations/supabase/client'
import { useAuth } from '@/lib/AuthProvider'

export const Route = createFileRoute('/sandbox')({
  component: SandboxLoader,
})

function SandboxLoader() {
  const navigate = useNavigate()
  const { user, isLoading } = useAuth()
  const [error, setError] = useState('')

  useEffect(() => {
    if (user?.email === 'demo@autowash.com' && !isLoading) {
      navigate({ to: '/app', replace: true })
    }
  }, [user, isLoading, navigate])

  useEffect(() => {
    const enterSandbox = async () => {
      try {
        if (user?.email === 'demo@autowash.com') return

        if (user) {
          await supabase.auth.signOut()
        }

        const { error: signInError } = await supabase.auth.signInWithPassword({
          email: 'demo@autowash.com',
          password: 'sandbox123',
        })

        if (signInError) throw signInError
      } catch (err: any) {
        console.error('Erro no Sandbox:', err)
        setError(
          'Não foi possível acessar o Sandbox. Verifique se o usuário demo foi configurado no Supabase.'
        )
      }
    }

    enterSandbox()
  }, [user])

  return (
    <div className="min-h-screen bg-slate-950 flex flex-col items-center justify-center p-4">
      <div className="bg-slate-900 border border-slate-800 p-8 rounded-2xl max-w-md w-full text-center shadow-2xl flex flex-col items-center">
        <div className="w-16 h-16 bg-blue-500/20 text-blue-400 rounded-full flex items-center justify-center mb-6">
          <Zap size={32} />
        </div>
        <h1 className="text-2xl font-bold text-white mb-2">Entrando no Sandbox</h1>
        <p className="text-slate-400 mb-8">
          Preparando seu ambiente de demonstração com dados simulados...
        </p>

        {error ? (
          <div className="bg-red-500/10 text-red-400 p-4 rounded-lg text-sm w-full border border-red-500/20">
            {error}
          </div>
        ) : (
          <Loader2 className="animate-spin text-blue-500" size={32} />
        )}
      </div>
    </div>
  )
}
